import type { ChangeBrief } from "./schema.js";

export const demoChange: ChangeBrief = {
  id: "chg-orders-contact-v1",
  sourceField: "orders.customer_email",
  targetField: "orders.customer_contact",
  sourceType: "STRING",
  targetType: "STRING(320)",
  summary: "Rename and widen a shared customer field before the Q4 model cutover.",
  affectedAssets: [
    "mart.marketing.customer_profile",
    "mart.sales.order_facts",
    "data_product.customer_360",
    "vw_reporting.customer_overview",
    "ml_feature.customer_contact_freq",
    "export.lifecycle_customer_sync",
    "handoff.support_customer_context",
  ],
  maintenanceWindow: {
    startsAt: "2026-09-12T02:00:00.000Z",
    endsAt: "2026-09-12T04:00:00.000Z",
  },
  owner: {
    name: "Alex Kim",
    phone: "+12025550148",
    region: "US",
    locale: "en-US",
    consentConfirmed: true,
    consentRecordedAt: "2026-08-15T10:24:00.000Z",
  },
  questions: [
    { id: "preferred-name", text: "Is customer_contact the preferred field name going forward?", answerType: "yes_no" },
    { id: "breaking-consumers", text: "Will any systems or contracts break because of this rename?", answerType: "short_text" },
    { id: "length", text: "Is the new length of 320 sufficient for all known use cases?", answerType: "yes_no" },
    { id: "transition", text: "Do you need a transition period with both fields available?", answerType: "short_text" },
  ],
};
